import React from "react";
import { Modal, ModalBody, ModalFooter } from "../../modal/Modal";
import './ExamineticsProgressModal.scss';

const ExamineticsProgressModal = ({ isShow, completedCount, totalCount, onContinue, onExit }) => {
    return (
        <Modal isOpen={isShow} centered className="examinetics-progress-modal">
            <ModalBody className="text-center">
                <h4 className="modal-title-custom">Continue your screening?</h4>
                
                <div className="progress-content">
                    <p>You&apos;ve completed {completedCount} of {totalCount} movements.</p>
                    <p>Your progress will be saved if you exit.</p>
                </div>
            </ModalBody>
            <ModalFooter className="justify-content-center">
                <div className="btn-container">
                    <button 
                        className="btn btn-continue" 
                        onClick={onContinue}
                    >
                        Continue Assessment
                    </button>
                    <button 
                        className="btn btn-exit" 
                        onClick={onExit}
                    >
                        Yes, Exit
                    </button>
                </div>
            </ModalFooter>
        </Modal>
    );
};

export default ExamineticsProgressModal;
